export default __webpack_public_path__ + "static/media/button-play-hover.de60a46d.svg";